import { BaseSerializer } from './base.serializer'
import { DateSerializer, TimeSerializer } from './attributes'
import { OnlineSession } from 'models'
import { CenterSerializer } from './center.serializer'
import { ProgramSerializer } from './program.serializer'
import { InterviewSerializer, InterviewResultlSerializer } from './interview.serializer'
import { UserSerializer } from './user.serializer'
import { CommentSerializer } from './comment.serializer'
import { AttachmentSerializer } from './attachment.serializer'
import { ExamRegistrationSerializer } from './exam-registration.serializer'
import { BriefingRegistrationSerializer } from './briefing-registration.serializer'
import { BriefingSerializer } from './briefing.serializer'

class ProgressSerializer {
  static serialize(progress: Object): string {
    return JSON.stringify(progress)
  }

  static deserialize(progress: string): Object {
    return JSON.parse(progress)
  }
}

export class OnlineSessionSerializer extends BaseSerializer<OnlineSession> {
  static SERIALIZABLE_ATTRIBUTES = ['comment', 'folderId', 'name', 'sections', 'centerProgram', 'attachments', 'progress']
  static SERIALIZERS = {
    progress: ProgressSerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    sections: 'sectionsAttributes',
    attachments: 'attachmentsAttributes',
  }

  static DESERIALIZERS = {
    attachments: AttachmentSerializer,
    createdAt: TimeSerializer,
    completedAt: TimeSerializer,
    canceledAt: TimeSerializer,
    updatedAt: TimeSerializer,
    examStartedAt: TimeSerializer,
    examCompletedAt: TimeSerializer,
    licenseIssuedAt: DateSerializer,
    scheduledAt: TimeSerializer,
    center: CenterSerializer,
    program: ProgramSerializer,
    interview: InterviewSerializer,
    interviewResult: InterviewResultlSerializer,
    interviewer: UserSerializer,
    onlineInterviewerComments: CommentSerializer,
    interviewRegistration: ExamRegistrationSerializer,
    briefingRegistration: BriefingRegistrationSerializer,
    progress: ProgressSerializer,
    briefing: BriefingSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): OnlineSession {
    return new OnlineSession(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/online-session.serializer.ts